import * as api from '../api/landModels';
import * as pricingTableApi from '../api/pricingTable';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN/LAND-MODELS';

export const FETCH_ALL_YEARS = createRequestTypes(`${prefix}/FETCH_ALL_YEARS`);

export const fetchAllYears = makeApiActionCreatorV3(
  pricingTableApi.fetchAllYears,
  FETCH_ALL_YEARS[START],
  FETCH_ALL_YEARS[SUCCESS],
  FETCH_ALL_YEARS[ERROR],
);

export const FETCH_MODEL_LAND_METHODS = createRequestTypes(
  `${prefix}/FETCH_MODEL_LAND_METHODS`,
);

export const fetchModelLandMethods = makeApiActionCreatorV3(
  api.fetchModelLandMethods,
  FETCH_MODEL_LAND_METHODS[START],
  FETCH_MODEL_LAND_METHODS[SUCCESS],
  FETCH_MODEL_LAND_METHODS[ERROR],
);

// common model land actions
export const FETCH_MODEL_LANDS = createRequestTypes(
  `${prefix}/FETCH_MODEL_LANDS`,
);

export const fetchModelLands = makeApiActionCreatorV3(
  api.fetchModelLands,
  FETCH_MODEL_LANDS[START],
  FETCH_MODEL_LANDS[SUCCESS],
  FETCH_MODEL_LANDS[ERROR],
);

export const INSERT_MODEL_LAND = createRequestTypes(
  `${prefix}/INSERT_MODEL_LAND`,
);

export const insertModelLand = makeApiActionCreatorV3(
  api.insertModelLand,
  INSERT_MODEL_LAND[START],
  INSERT_MODEL_LAND[SUCCESS],
  INSERT_MODEL_LAND[ERROR],
);

export const FETCH_MODEL_LAND = createRequestTypes(
  `${prefix}/FETCH_MODEL_LAND`,
);

export const fetchModelLand = makeApiActionCreatorV3(
  api.fetchModelLand,
  FETCH_MODEL_LAND[START],
  FETCH_MODEL_LAND[SUCCESS],
  FETCH_MODEL_LAND[ERROR],
);

export const UPDATE_MODEL_LAND = createRequestTypes(
  `${prefix}/UPDATE_MODEL_LAND`,
);

export const updateModelLand = makeApiActionCreatorV3(
  api.updateModelLand,
  UPDATE_MODEL_LAND[START],
  UPDATE_MODEL_LAND[SUCCESS],
  UPDATE_MODEL_LAND[ERROR],
);

export const DELETE_MODEL_LAND = createRequestTypes(
  `${prefix}/DELETE_MODEL_LAND`,
);

export const deleteModelLand = makeApiActionCreatorV3(
  api.deleteModelLand,
  DELETE_MODEL_LAND[START],
  DELETE_MODEL_LAND[SUCCESS],
  DELETE_MODEL_LAND[ERROR],
);

// model land ranges
export const FETCH_MODEL_LAND_RANGES = createRequestTypes(
  `${prefix}/FETCH_MODEL_LAND_RANGES`,
);

export const fetchModelLandRanges = makeApiActionCreatorV3(
  api.fetchModelLandRanges,
  FETCH_MODEL_LAND_RANGES[START],
  FETCH_MODEL_LAND_RANGES[SUCCESS],
  FETCH_MODEL_LAND_RANGES[ERROR],
);

export const FETCH_MODEL_LAND_RANGE = createRequestTypes(
  `${prefix}/FETCH_MODEL_LAND_RANGE`,
);

export const fetchModelLandRange = makeApiActionCreatorV3(
  api.fetchModelLandRange,
  FETCH_MODEL_LAND_RANGE[START],
  FETCH_MODEL_LAND_RANGE[SUCCESS],
  FETCH_MODEL_LAND_RANGE[ERROR],
);

export const INSERT_MODEL_LAND_RANGE = createRequestTypes(
  `${prefix}/INSERT_MODEL_LAND_RANGE`,
);

export const insertModelLandRange = makeApiActionCreatorV3(
  api.insertModelLandRange,
  INSERT_MODEL_LAND_RANGE[START],
  INSERT_MODEL_LAND_RANGE[SUCCESS],
  INSERT_MODEL_LAND_RANGE[ERROR],
);

export const UPDATE_MODEL_LAND_RANGE = createRequestTypes(
  `${prefix}/UPDATE_MODEL_LAND_RANGE`,
);

export const updateModelLandRange = makeApiActionCreatorV3(
  api.updateModelLandRange,
  UPDATE_MODEL_LAND_RANGE[START],
  UPDATE_MODEL_LAND_RANGE[SUCCESS],
  UPDATE_MODEL_LAND_RANGE[ERROR],
);

export const DELETE_MODEL_LAND_RANGE = createRequestTypes(
  `${prefix}/DELETE_MODEL_LAND_RANGE`,
);

export const deleteModelLandRange = makeApiActionCreatorV3(
  api.deleteModelLandRange,
  DELETE_MODEL_LAND_RANGE[START],
  DELETE_MODEL_LAND_RANGE[SUCCESS],
  DELETE_MODEL_LAND_RANGE[ERROR],
);

export const APPLY_ADJUSTMENT_FACTOR = createRequestTypes(
  `${prefix}/APPLY_ADJUSTMENT_FACTOR`,
);

export const applyAdjustmentFactor = makeApiActionCreatorV3(
  api.applyAdjustmentFactor,
  APPLY_ADJUSTMENT_FACTOR[START],
  APPLY_ADJUSTMENT_FACTOR[SUCCESS],
  APPLY_ADJUSTMENT_FACTOR[ERROR],
);

export const FETCH_MODEL_LAND_PRICING_SCHEDULES = createRequestTypes(
  `${prefix}/FETCH_MODEL_LAND_PRICING_SCHEDULES`,
);

export const fetchModelLandPricingSchedules = makeApiActionCreatorV3(
  api.fetchModelLandPricingSchedules,
  FETCH_MODEL_LAND_PRICING_SCHEDULES[START],
  FETCH_MODEL_LAND_PRICING_SCHEDULES[SUCCESS],
  FETCH_MODEL_LAND_PRICING_SCHEDULES[ERROR],
);

export const DELETE_MODEL_LAND_PRICING_SCHEDULE = createRequestTypes(
  `${prefix}/DELETE_MODEL_LAND_PRICING_SCHEDULE`,
);

export const deleteModelLandPricingSchedule = makeApiActionCreatorV3(
  api.deleteModelLandPricingSchedule,
  DELETE_MODEL_LAND_PRICING_SCHEDULE[START],
  DELETE_MODEL_LAND_PRICING_SCHEDULE[SUCCESS],
  DELETE_MODEL_LAND_PRICING_SCHEDULE[ERROR],
);

export const SET_MODEL_LAND_PRICING_SCHEDULE_BASE = createRequestTypes(
  `${prefix}/SET_MODEL_LAND_PRICING_SCHEDULE_BASE`,
);

export const setModelLandPricingScheduleBase = makeApiActionCreatorV3(
  api.setModelLandPricingScheduleBase,
  SET_MODEL_LAND_PRICING_SCHEDULE_BASE[START],
  SET_MODEL_LAND_PRICING_SCHEDULE_BASE[SUCCESS],
  SET_MODEL_LAND_PRICING_SCHEDULE_BASE[ERROR],
);

export const INSERT_MODEL_LAND_PRICING_SCHEDULE = createRequestTypes(
  `${prefix}/INSERT_MODEL_LAND_PRICING_SCHEDULE`,
);

export const insertModelLandPricingSchedule = makeApiActionCreatorV3(
  api.insertModelLandPricingSchedule,
  INSERT_MODEL_LAND_PRICING_SCHEDULE[START],
  INSERT_MODEL_LAND_PRICING_SCHEDULE[SUCCESS],
  INSERT_MODEL_LAND_PRICING_SCHEDULE[ERROR],
);
